
import { AssetPreviewNavigationController } from './asset-preview-navigation.controller'

function assetPreviewNavigation () {
  return {
    restrict: 'E',
    scope: {
      currentAsset: '=',
      previewFlags: '=',
      getPreviewAssets: '<'
    },
    templateUrl: '/core/directives/asset-preview-navigation/asset-preview-navigation.html?$$REVISION$$',
    controller: AssetPreviewNavigationController
  }
}
export { assetPreviewNavigation }
